import { useAppContext } from '@/context/AppContext';
import { isAgentLaunch } from '@/utils/agentSession';
import { resolveRhiVersion, RhiVersion } from '@/utils/rhiVersion';

/**
 * The RHI journey this user gets. Undefined until `/me` has loaded, so a v2 user is never
 * shown a v1 page while their flags are on the way.
 */
export const useRhiVersion = (): RhiVersion | undefined => {
  const { userConfig, isAppLoading } = useAppContext();
  const isAgent = isAgentLaunch();

  if (!isAgent && isAppLoading && !userConfig) return undefined;

  return resolveRhiVersion({ featureFlags: userConfig?.featureFlags, isAgent });
};

export default useRhiVersion;
